import { Page } from '@/core/architecture'

import { ArtistEventsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistEvents Page
 * Implemented as a practical sample.
 */
export const ArtistEvents: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistEventsTemplate state={state} {...actions} />
}
